import { Button, Checkbox, Input } from '@fluentui/react-components';
import { Add24Regular, Delete24Regular } from '@fluentui/react-icons';

import type { ParamsPanelProps } from './ParamsPanel.interface.js';
import { useStyles } from './ParamsPanel.style.js';

export function ParamsPanel({
  pairs,
  onChange,
  placeholder = { key: 'Name', value: 'Value' },
}: ParamsPanelProps) {
  const styles = useStyles();

  function handleAdd() {
    onChange([
      ...pairs,
      { id: crypto.randomUUID(), key: '', value: '', enabled: true },
    ]);
  }

  function handleDelete(id: string) {
    onChange(pairs.filter((p) => p.id !== id));
  }

  function handleChange(id: string, field: 'key' | 'value', val: string) {
    onChange(pairs.map((p) => (p.id === id ? { ...p, [field]: val } : p)));
  }

  function handleToggle(id: string, checked: boolean) {
    onChange(pairs.map((p) => (p.id === id ? { ...p, enabled: checked } : p)));
  }

  return (
    <div className={styles.root}>
      {pairs.map((pair) => (
        <div key={pair.id} className={styles.row}>
          <Checkbox
            checked={pair.enabled}
            onChange={(_, d) => handleToggle(pair.id, d.checked === true)}
          />
          <Input
            className={styles.keyInput}
            placeholder={placeholder.key}
            value={pair.key}
            onChange={(_, d) => handleChange(pair.id, 'key', d.value)}
            size="small"
          />
          <Input
            className={styles.valueInput}
            placeholder={placeholder.value}
            value={pair.value}
            onChange={(_, d) => handleChange(pair.id, 'value', d.value)}
            size="small"
          />
          <Button
            appearance="subtle"
            icon={<Delete24Regular />}
            size="small"
            onClick={() => handleDelete(pair.id)}
          />
        </div>
      ))}
      <Button
        className={styles.addBtn}
        appearance="subtle"
        icon={<Add24Regular />}
        size="small"
        onClick={handleAdd}
      >
        Add
      </Button>
    </div>
  );
}
